import { render, staticRenderFns } from "./building-editor.vue?vue&type=template&id=beded90c"
import script from "./building-editor.ts?vue&type=script&lang=js&external"
export * from "./building-editor.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports